import { getConfig } from './config'

export interface FileCreate {
  labCode: string;
  sha1: string;
}

export interface ExtractorCreate {
  age: string;
  imc: string;
  gender: string;
  pregnant: undefined | null | 'not-pregnant' | 'pregnant';
  hasMenopause: undefined | null | 'menopause' | 'not-menopause';
  files: FileCreate[];
}

export interface ApplyRulesExam {
  examId: string
  result: number
  measurement: string
}

export interface ApplyRulesCreate {
  age: string
  imc: string
  gender: string
  pregnant: undefined | null | 'not-pregnant' | 'pregnant'
  hasMenopause: undefined | null | 'menopause' | 'not-menopause'
  exams: ApplyRulesExam[]
}

export interface FileResponse {
  sha1: string;
  isUploaded: boolean;
}

export interface ExtractorCreateResponse {
  key: string;
  files: FileResponse[];
  path: string;
}

export interface ApplyRulesCreateResponse {
  key: string
  typed: 'typed'
}

export interface AgeRange {
  type: string;
  values: number[];
}

export interface Reference {
  gender: string;
  ageRange: AgeRange;
  type: string;
  values: number[];
  pregnancy: string;
}

export interface Extracted {
  name: string;
  method: string;
  material: string;
  result: number;
  measurement: string;
  references?: Reference[];
  lab: string;
  examId?: string;
}

export interface Category {
  _id: string;
  name: string;
}

export interface Content {
  type: string;
  _id: string;
  text: string;
  source: string;
}

export interface Exam {
  name: string;
  method: string;
  material: string;
  result: number;
  measurement: string;
  lab: string;
  references?: Reference[];
  content: Content[];
  _id: string;
  isConverted: boolean;
}

export interface Rule {
  exam: Exam;
}

export interface CalculatedExam {
  values: string[];
  calculatedValue: number;
  operator: string;
}

export interface Result {
  _id: string;
  name: string;
  code: string;
  categories: Category[];
  severity: string;
  content: Content[];
  calculatedExams: CalculatedExam[];
  rules: Rule[];
}

export interface AppliableRule {
  name: string;
  code: string;
  categories: Category[];
  severity: string;
  content: Content[];
}

export interface ConvertedValue {
  name: string;
  method: string;
  material: string;
  result: number;
  measurement: string;
  lab: string;
  _id: string;
  convertedValue: number;
}
export interface Patient {
  imc: string | number;
  age: string | number;
  sex: 'male' | 'female';
}

export interface ExtractedResponse {
  error?: boolean;
  status?: 'pending' | 'fulfilled' | 'error';
  extracted?: Extracted[];
  result?: Result[];
  totalAppliableRules?: number;
  appliableRules?: AppliableRule[];
  convertedValues?: ConvertedValue[];
  patient?: Patient;
}

export const createExtraction =
  async (params: ExtractorCreate): Promise<ExtractorCreateResponse> => {
    const config = getConfig()
    const response = await config.axios.post<ExtractorCreateResponse>(
      `${config.API_URL}/extractor`,
      params
    )

    return response.data
  }

export const applyRuleAsync =
  async (params: ApplyRulesCreate): Promise<ApplyRulesCreateResponse> => {
    const config = getConfig()
    const response = await config.axios.post<ApplyRulesCreateResponse>(
      `${config.API_URL}/applyRules/async`,
      params
    )

    return response.data
  }

export const getAsyncResponse = async (key: string): Promise<ExtractedResponse> => {
  const config = getConfig()

  const url = `${config.API_URL}/extractor/${key}`

  const response = await config.axios.get<ExtractedResponse>(url)

  return response.data
}
